import { render, staticRenderFns } from "./SingleMDA.vue?vue&type=template&id=1c5bdde2&"
import script from "./SingleMDA.vue?vue&type=script&lang=js&"
export * from "./SingleMDA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports